import React, {useEffect, useMemo, useRef, useState} from "react";
import {useSearchParams} from "react-router-dom";
import connect from "react-redux/es/components/connect";
import {Loading} from "../../../components/common";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormLabel,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow
} from "@coreui/react";
import * as o2Api from "../../../api/api";
import numeral from "numeral";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import * as formatter from "../../../config/formatter";
import DefaultLayout from "../../../layout/DefaultLayout";
import StoreListWhere from "../where/StoreListWhere";
import StoreCornerListWhere from "../where/StoreCornerListWhere";
import StoreDetail from "../store/StoreDetail";
import {useSelector} from "react-redux";


const PopupProductForm = (props) => {

    const { user } = useSelector((props) => props.account);

    console.log("props::: " , props);


    const [params] = useSearchParams();

    props.selected.cmpCd  = params.get("cmpCd");
    props.selected.brandCd  = params.get("brandCd");
    props.selected.storeCd  = params.get("storeCd");
    props.selected.prtNo  = params.get("prtNo");
    props.selected.userId  = params.get("userId");

    console.log("cmpCd::: " , params.get("cmpCd") + "/// brandCd::: " + params.get("brandCd") + "/// storeCd::: " +params.get("storeCd")+ "/// prtNo::: " + params.get("prtNo"));




    const [company, setCompany] = useState([{cmpCd: "", cmpNm: "전체"}]);
    const [brand, setBrand] = useState([{brandCd: "", brandNm: "전체"}]);
    const [store, setStore] = useState([{storeCd: "", storeNm: "전체"}]);
    const [corner, setCorner] = useState([{cornerCd: "", cornerNm: "전체"}]);


   const {cmpCd, brandCd, storeCd, prtNo, userId} = props.selected;


   /*const {user} = {
       cmpCd : cmpCd,
       brandCd : brandCd,
       storeCd : storeCd,
       userId : storeCd
   };*/


    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%" }), []);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]); //그리드
    const [searchForm, setSearchForm] = useState({
        cmpCd: cmpCd, brandCd:brandCd, storeCd: storeCd, useYn:""
    });


    useEffect(() => {

    }, []);

    const [columnDefs] = useState([
        {
            field: "isUse",
            headerName: "No",
            width: 40,
            headerCheckboxSelection: true
            ,checkboxSelection: (params) => {
                return params.data.isUse !== null ? 'true' : 'false';
            },
            valueFormatter: (e) => {
                return e.data.isUse !== null ? "" : "";
            }
        },
        {field: "seq", headerName: "시퀀스", width: 120, hide:true},
        {field: "restProductCd", headerName: "상품코드", width: 120},
        {field: "productCd", headerName: "상품코드", width: 120, hide:true},
        {field: "productNm", headerName: "상품명", width: 180},
        {field: "sourceCd", headerName: "바코드", width: 200},
        //{field: "supPrice", headerName: "원가", minWidth: 100},
        {field: "price", headerName: "판매단가", Width: 50},
        {field: "productDiv", headerName: "상품구분", width: 80, hide:true},
        {field: "bagYn", headerName: "봉투사용여부", Width: 20},
        {field: "bagPrice", headerName: "봉투금액", width: 80}
    ]);

    //여기부터 코드 재사용(StoreCornerListWhere)하도록 수정할것
    useEffect(() => {
        getCompany();
    }, []);

    const handleSelect = (e, value) => {
        if (value === "C") {
            props.onSelect(e.target.value, "C");
            getBrand(e.target.value);
        } else if (value === "B") {
            props.onSelect(e.target.value, "B");
            getStore(props.selected.cmpCd, e.target.value);
        } else if (value === "S") {
            props.onSelect(e.target.value, "S");
            getCorner(props.selected.cmpCd, props.selected.brandCd, e.target.value)
        } else if (value === "O") {
            props.onSelect(e.target.value, "O");
        }
    };

    const getCompany = async () => {
        console.log("props.selected.cmpCd::; " , props.selected.cmpCd);
        if (props.selected.cmpCd !== null) {
            const {data: result} = await o2Api.getCompany(props.selected.cmpCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setCompany([responseBody]);
                //props.onSelect(props.selected.cmpCd, "C");
                getBrand(props.selected.cmpCd);
            }
        } else {
            const params = {
                userId: user.userId
            }

            const {data: result} = await o2Api.getCompanyList(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setCompany([{cmpCd: "", cmpNm: "전체"}]);
                setCompany((state) => state.concat(responseBody));
            }
        }
    };

    const getBrand = async (cmpCd) => {
        if (props.selected.brandCd !== null) {
            const {data: result} = await o2Api.getBrand(props.selected.cmpCd, props.selected.brandCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                //props.onSelect(props.selected.brandCd, "B");
                setBrand([responseBody]);

                getStore(props.selected.cmpCd, props.selected.brandCd);
            }
        } else {
            const {data: result} = await o2Api.getBrandList(cmpCd);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                setBrand([{brandCd: "", brandNm: "전체"}]);
                setBrand((state) => state.concat(responseBody));
            }
        }
    };

    const getStore = async (cmpCd, brandCd) => {
        if (props.selected.storeCd !== null) {
            const params = {
                cmpCd: props.selected.cmpCd,
                brandCd: props.selected.brandCd,
                storeCd: props.selected.storeCd,
                manageDiv: "0",
                userId: "yeom"
            };

            console.log("params::; ", params);

            const {data: result} = await o2Api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                if (responseBody != null) {
                    // 성공
                    //props.onSelect(props.selected.storeCd, "S");
                    setStore(responseBody);
                }
            }
        } else {
            const params = {
                cmpCd: cmpCd,
                brandCd: brandCd,
                manageDiv: "0",
                userId: 'yeom'
            };

            const {data: result} = await o2Api.getStoreWhere(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                if (responseBody != null) {
                    // 성공
                    setStore([{storeCd: "", storeNm: "전체"}]);
                    setStore((state) => state.concat(responseBody));
                }
            }
        }
    };

    const getCorner = async (cmpCd, brandCd, storeCd) => {
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd
        };

        const {data: result} = await o2Api.getStoreCorner(params);
        const {responseBody, responseCode, responseMessage} = result;
        if (responseCode === "200") {
            if (responseBody != null) {
                // 성공
                setCorner([{cornerCd: "", cornerNm: "전체"}]);
                setCorner((state) => state.concat(responseBody));
            }
        }
    };
    //일단 나중에 처리할 것!


    const onCheck = (e) => {
        console.log("checked :: ", e);
    }

    //Start 조회
    const search = async () => {
        setError({
            visible: false,
            message: ""
        });

        const {cmpCd, brandCd, storeCd, useYn} = searchForm;
        /*if (cornerCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 코너는 반드시 선택하셔야 합니다."
            });
            return;
        }*/

        // 조회 조건에 따라 분기
        setLoading(true);
        // cmpCd 는 필수
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            //cornerCd: cornerCd,
            productNm: searchForm.productNm,
            restProductCd: searchForm.restProductCd,
            barcode: searchForm.barcode,
            isUse: searchForm.isUse
        };
        const { data: result } = await o2Api.getRestProduct(params);
        const { responseBody, responseCode, responseMessage } = result;
        if (responseCode === "200") {
            if (responseBody != null) {
                setGridData(responseBody);
            }
        }
        setLoading(false);
    }; //End 조회

    const save = async () => {
        const { api } = gridRef.current;
        if (api === null) return;

        const {cmpCd, brandCd, storeCd, prtNo, userId} = props.selected;
        const selectRows = api.getSelectedRows();
        if (selectRows === 0) return;

        if (confirm("주방프린터 상품으로 등록 하시겠습니까?")) {
            const { cmpCd, brandCd, storeCd, cornerCd } = searchForm;
            const params = [];
            selectRows.map((item) => {
                const data = {
                    cmpCd: cmpCd,
                    brandCd: brandCd,
                    storeCd: storeCd,
                    //cornerCd: cornerCd,
                    productCd: item.productCd,
                    prtNo: parseInt(prtNo),  //받아야함
                    seq : item.seq,
                    useYn : 'Y',
                    instUser : userId,
                    updUser : userId

                };
                params.push(data);
            });
            console.log("상품 등록 전 params : ", params);

            try {
                const { data: result } = await o2Api.putStorePrtProduct(params);
                const { responseBody, responseCode, responseMessage } = result;
                if (responseCode === "200") {
                    if (responseBody != null) {
                        alert("처리되었습니다.");
                        window.close();
                    }
                }
            } catch (e) {
                console.log(e) // caught
            }


           /* if (selectRows[0].isUse !== null) {
                return; //잠시
                const { data: result } = await o2Api.deleteProductStore(params);
                const { responseBody, responseCode, responseMessage } = result;
                console.log("### response :: ", responseBody);
                if (responseCode === "200") {
                    if (responseBody != null) {
                        search();
                    }
                }
            }
            else {

                console.log("저장 전");
                const { data: result } = await o2Api.putStorePrtProduct(params);
                const { responseBody, responseCode, responseMessage } = result;
                if (responseCode === "200") {
                    if (responseBody != null) {
                        search();
                    }
                }
            }*/
        }
    };


    /*###################화면 Grid 영역###########################*/
    return (
        <>
            <div style={{height: 10}}/>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                {loading ? <Loading/> : null}
                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>

                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 70}}>운영사</CInputGroupText>
                            <CFormSelect id="company"
                                         value={props.selected.cmpCd}
                                         onChange={(e) => handleSelect(e, "C")} >
                                {company.map((item, index) => {
                                    return (
                                        <option key={index} value={item.cmpCd}>{item.cmpNm}</option>
                                    );
                                })}
                            </CFormSelect>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 70}}>휴게소</CInputGroupText>
                            <CFormSelect id="brand"
                                         value={props.selected.brandCd}
                                         onChange={(e) => handleSelect(e, "B")}>
                                {brand.map((item, index) => {
                                    return (
                                        <option key={index} value={item.brandCd}>{item.brandNm}</option>
                                    );
                                })}
                            </CFormSelect>
                        </CInputGroup>
                    </CCol>

                    <CCol xs={12}>
                        <CInputGroup size="sm">
                            <CInputGroupText style={{width: 70}}>매장</CInputGroupText>
                            <CFormSelect id="store"
                                         value={props.selected.storeCd ? props.selected.storeCd : props.selected.storeCd}
                                         onChange={(e) => handleSelect(e, "S")}>
                                {store.map((item, index) => {
                                    return (
                                        <option key={index} value={item.storeCd}>{item.storeNm}</option>
                                    );
                                })}
                            </CFormSelect>
                        </CInputGroup>
                    </CCol>
                </CForm>

                     <div style={{height: 10}}/>

                    <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>

                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{width: 80}}>상품코드</CInputGroupText>
                            <CFormInput id="productCd"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                restProductCd: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{width: 80}}>상품명</CInputGroupText>
                            <CFormInput id="productNm"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                productNm: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{width: 80}}>바코드</CInputGroupText>
                            <CFormInput id="barcode"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                barcode: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{width: 80}}>사용유무</CInputGroupText>
                            <CFormSelect onChange={(e) => {
                                setSearchForm((state) => ({
                                    ...state,
                                    isUse: e.target.value
                                }));
                            }}>
                                <option value={""}>전체상품</option>
                                <option value={"Y"}>사용중</option>
                            </CFormSelect>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CButton size={"sm"} onClick={search}>조회</CButton>
                        <CButton style={{marginLeft: 10}} size={"sm"} onClick={save}>저장</CButton>
                    </CCol>



                </CForm>

                <div style={{height: 10}}/>
                <div className="ag-theme-alpine" style={{width: "100%", height: 500, marginTop: 10}}>
                    <AgGridReact
                        ref={gridRef}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={gridData}
                        animateRows={true}
                        columnDefs={columnDefs}
                        rowSelection="multiple">
                    </AgGridReact>
                </div>
            </div>
        </>
    )
}



const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};
export default connect(mapStateToProps, null)(PopupProductForm);

